// extracted by mini-css-extract-plugin
export default {"wrapper":"SomeoneSpecial_wrapper__S86SK","submit_error":"SomeoneSpecial_submit_error__4mvva"};